export default import.meta.ROLLDOWN_FILE_URL_E1oT5XVqd9fm5KE3Ey4O5A